import { ITemplatePreview, ITemplate } from "constants/template-types";
import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { ATS_CUSTOM_TEMPLATES } from "../constants/action-types";
import { fetchActions, IFetchStoreState, progressActions, initialFetchState, updateActions } from "./base-reducers";

export interface IAtsCustomTemplates extends IFetchStoreState<ITemplatePreview[]> {}

export interface IAtsCustomTemplate extends IFetchStoreState<ITemplate> {
    isCreating: boolean;
}

export interface IAtsCustomTemplatesState {
    list: IAtsCustomTemplates;
    template: IAtsCustomTemplate;
}

export const atsCustomTemplates = combineReducers<IAtsCustomTemplatesState>({
    list: handleActions<IAtsCustomTemplates>(
        {
            ...fetchActions(ATS_CUSTOM_TEMPLATES.LIST.FETCH),
            ...updateActions(ATS_CUSTOM_TEMPLATES.LIST),
        } as any,
        { ...initialFetchState },
    ),
    template: handleActions<IAtsCustomTemplate>(
        {
            ...progressActions(ATS_CUSTOM_TEMPLATES.FETCH, "isFetching"),
            ...updateActions(ATS_CUSTOM_TEMPLATES),
        } as any,
        {
            ...initialFetchState,
            isCreating: false,
        },
    ),
});
